import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// Called once on page load — full combo list for client-side cascade
export const GetNetworkCombosRequest = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}Sites/GetNetworkCombos` });

// Called on mount + Apply button
// If exactly 1 value selected → send to backend (SQL filters it)
// If 0 or multiple selected  → send nothing (backend returns all)
export const GetAllSitesRequest = (filters) => {
	const params = {};
	if (filters.technologies?.length === 1) params.technology      = filters.technologies[0];
	if (filters.vendors?.length      === 1) params.vendor          = filters.vendors[0];
	if (filters.servers?.length      === 1) params.server          = filters.servers[0];
	if (filters.tacs?.length         === 1) params.tac             = filters.tacs[0];
	if (filters.windowStart)               params.windowStart      = filters.windowStart;
	if (filters.windowEnd)                 params.windowEnd        = filters.windowEnd;
	if (filters.activityStatus)            params.activityStatus   = filters.activityStatus;
	return AxiosRequest({ method: 'GET', url: `${config.API_URL}Sites/GetAllSites`, params });
};

// Called when user clicks a site marker — fetches all activities for that site
export const GetSiteActivitiesRequest = ({ csr, technology, vendor, omcId, tac, activityStatus }) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Sites/GetSiteActivities`,
		params: { csr, technology, vendor, omcId, tac, activityStatus },
	});